export const objectToQueryString = obj => Object.keys(obj)
  .map(key => ''.concat(`${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`))
  .join('&');
